import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useConfig } from '../../Hooks/useConfig';
import { showErrorToast } from '../toast.jsx';

export function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export const copyContent = async (text) => {
  var textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed'; // To prevent scrolling to the textarea
  document.body.appendChild(textArea);

  // Select the text
  textArea.focus();
  textArea.select();

  try {
    // Copy the selected text
    var successful = document.execCommand('copy');
  } catch (err) {}

  document.body.removeChild(textArea); // Remove the textarea
};
export const numberWithCommas = (number) => {
  return new Intl.NumberFormat().format(number);
};
export function checkAndFixUrl(url) {
  if (!url.startsWith('https') && !url.startsWith('http')) {
    url = 'https://' + url;
  }
  return url;
}
export const formatDateOne = (dateStr) => {
  // same March 15, 2020
  const formattedDate = dayjs(dateStr).format('MMMM D, YYYY');
  return formattedDate;
};
export const formatDateTwo = (dateStr) => {
  // same "MMM YYYY,DD"

  const formattedDate = dayjs(dateStr).format('MM/DD/YYYY');
  return formattedDate;
};

export const formatDateThree = (dateStr) => {
  // same "MMM YYYY,DD"

  const formattedDate = dayjs(dateStr).format('MMM YYYY, DD');
  return formattedDate;
};

export const GetItemHistoryById = (data, id) => {
  return data.find((item) => item.id === id);
};

export const capitalizeString = (str) => {
  // Convert the string to lowercase and split it by underscores
  let words = str.toLowerCase().split('_');

  // Capitalize the first letter of each word
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }

  // Join the words with spaces
  let capitalizedString = words.join(' ');

  return capitalizedString;
};

export const addCommasToDigits = (num) => {
  return num.toLocaleString();
};

export const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const loadPaddleFromCDN = (token) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdn.paddle.com/paddle/paddle.js';
    script.onload = () => {
      window.Paddle.Setup({ vendor: token });
      resolve(window.Paddle);
    };
    script.onerror = (error) => reject(error);
    document.head.appendChild(script);
  });
};

export function formatNumberWithUnit(num) {
  const absNum = Math.abs(num); // Get the absolute value to handle negative numbers
  // Check for trillions
  if (absNum >= 1_000_000_000_000) {
    return (num / 1_000_000_000_000).toFixed(2) + 't';
  }
  // Check for billions
  else if (absNum >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(2) + 'b';
  }
  // Check for millions
  else if (absNum >= 1_000_000) {
    return (num / 1_000_000).toFixed(2) + 'm';
  }
  // Check for thousands
  else if (absNum >= 1_000) {
    return (num / 1_000).toFixed(2) + 'k';
  }
  // For smaller numbers, display with two decimal places
  else {
    return num;
  }
}

export const formikErrorMessage = (formikObj, fieldName) => {
  return formikObj.errors[fieldName] && formikObj.touched[fieldName]
    ? formikObj.errors[fieldName]
    : null;
};

export const formikErrorInput = (formikObj, fieldName) => {
  return formikObj.errors[fieldName] && formikObj.touched[fieldName];
};

export const returnToPricing = async (history, openCreditsBalanceModal) => {
  const { panelUrl } = useConfig();
  if (openCreditsBalanceModal) {
    const project = panelUrl.includes(window.location.hostname)
      ? 'panel'
      : 'playground';

    // showErrorToast("You don't have any credits left", { autoClose: 3000 });
    await timeout(3000);

    if (project === 'panel') {
      history.push('/billing/pricing');
    } else if (project === 'playground') {
      window.location.href = `${panelUrl}/billing/pricing`;
    }
  }
};

export const formatToLocalTime = (dateString) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  // Parse the input date as UTC
  const utcDate = dayjs.utc(dateString);

  // Convert to local timezone
  const localDate = utcDate.local();

  // Format the date
  return localDate.format('MMMM D, YYYY, hh:mm A');
};

export const getValidValue = (value) => {
  if (value && typeof value === 'string' && value.includes('This value is hidden')) {
    return null;
  }
  return value;
};
